import { HirerAuthProvider } from '@seek/hirer-auth-react';
import { HirerApolloProvider } from '@seek/hirer-graphql-react';
import { UivBanner } from '@seek/uiv-banner';
import { VocabProvider } from '@vocab/react';
import { BraidProvider } from 'braid-design-system';
import seekJobs from 'braid-design-system/themes/seekJobs';
import type { ReactNode } from 'react';

import { AnalyticsProvider } from 'src/modules/analytics';
import { useConfig } from 'src/modules/appConfig';
import { dataManagerConfig } from 'src/modules/dataManager';
import { HeaderFooterBasicStateProvider } from 'src/modules/headerFooterBasicContext/context';
import { useStore } from 'src/store/hooks';
import { MainLayout } from 'src/views/layouts/MainLayout/MainLayout';
import { LinkComponent } from 'src/views/shared/Link';

interface AppContentProps {
  children: ReactNode;
}

export const AppContent = ({ children }: AppContentProps) => {
  const { environment, site, language, useAuth, branch, version } = useConfig();
  const store = useStore();

  const apolloProviderProps = dataManagerConfig({
    site,
    environment,
    useAuth,
  });

  const mockAuth = environment === 'dev' && !useAuth;

  return (
    <BraidProvider theme={seekJobs} linkComponent={LinkComponent}>
      <UivBanner
        applicationName="hirer-invoices-ui"
        branch={branch}
        version={version}
      />
      <VocabProvider language={language}>
        <AnalyticsProvider value={{ store }}>
          <HirerAuthProvider authenticationLevel={mockAuth ? 'Mocked' : 'None'}>
            <HirerApolloProvider {...apolloProviderProps}>
              <HeaderFooterBasicStateProvider>
                <MainLayout>{children}</MainLayout>
              </HeaderFooterBasicStateProvider>
            </HirerApolloProvider>
          </HirerAuthProvider>
        </AnalyticsProvider>
      </VocabProvider>
    </BraidProvider>
  );
};
